module.exports = __webpack_public_path__ + "img/call.44876971.svg";